export default __webpack_public_path__ + "static/media/ic_medium.d9c8d763.svg";